<div class="image-by-id-wrap">
  <img
    *ngIf="imageSrc && !loading && !errored"
    [src]="imageSrc"
    [alt]="altText || 'Image'"
    [style.width]="imageWidth ? imageWidth + 'px' : null"
  />
  <button
    *ngIf="imageSrc && !loading && !errored && showDownloadButton"
    type="button"
    class="image-by-id-download-btn"
    [ngClass]="'image-by-id-download-btn-' + (downloadButtonPosition || 'top-right')"
    [disabled]="downloading"
    [attr.aria-label]="'Download ' + (altText || 'image')"
    (click)="downloadImage()"
  >
    <i class="fa-solid" [ngClass]="downloading ? 'fa-spinner fa-spin' : 'fa-download'"></i>
  </button>
  <div *ngIf="loading" class="image-by-id-status">Loading image...</div>
  <div *ngIf="errored" class="image-by-id-status has-error">
    Unable to load image
  </div>
  <div *ngIf="!loading && !errored && !imageSrc" class="image-by-id-status">
    {{ emptyMessage || 'No image' }}
  </div>
</div>
